import React, { Children } from 'react';

import { SortingProps, Table, TableRenderProps } from '@block-explorer/ui';
import { TableRowType } from '@make-software/cspr-design';

import TableSettings, {
  PaginationProps,
} from '../table-settings/table-settings';
import { TableLoader } from '../page-data-table/table-loader';
import {
  NoDataFoundTableError,
  TableError,
} from '../page-data-table/table-error';

type RenderProps = TableRenderProps & { sortingProps: SortingProps };

export interface TabDataTableProps<Entity> {
  data: undefined | null | Entity[];
  loading: boolean;
  error?: string | null;
  noDataError?: boolean;
  paginationProps: PaginationProps;
  sortingProps: SortingProps;
  renderDataHeader: (renderProps: RenderProps) => JSX.Element;
  renderPaginatedData: (
    paginatedData: Entity[],
    renderProps: RenderProps
  ) => JSX.Element | JSX.Element[];
  tableRowType?: TableRowType;
}

export const TabDataTable = <Entity extends any>({
  data,
  paginationProps,
  sortingProps,
  loading,
  error,
  noDataError,
  renderPaginatedData,
  renderDataHeader,
  tableRowType,
}: TabDataTableProps<Entity>) => {
  const footerPagination = () => <TableSettings {...paginationProps} />;

  return (
    <Table
      renderDataHeaders={(renderProps) =>
        renderDataHeader({ ...renderProps, sortingProps: sortingProps! })
      }
      renderData={(renderProps) =>
        data == null || loading ? (
          <TableLoader
            columnsLength={Children.count(
              renderDataHeader({
                ...renderProps,
                sortingProps: sortingProps!,
              }).props.children
            )}
            rowsLength={paginationProps!.perPage}
            tableRowType={tableRowType}
          />
        ) : error ? (
          <TableError
            columnsLength={Children.count(
              renderDataHeader({
                ...renderProps,
                sortingProps: sortingProps!,
              }).props.children
            )}
          />
        ) : noDataError ? (
          <NoDataFoundTableError
            columnsLength={Children.count(
              renderDataHeader({
                ...renderProps,
                sortingProps: sortingProps!,
              }).props.children
            )}
          />
        ) : (
          renderPaginatedData(data, {
            ...renderProps,
            sortingProps: sortingProps!,
          })
        )
      }
      renderFooter={footerPagination}
    />
  );
};

export default TabDataTable;
